/* The Certificates drawer on Scope 2 - tokens only. The form's own boxes (.form, .field, .pair, .hint,
   .actions, .primary, .ghost, .done) are scopeTable.module.css's, shared with the Add drawer. */

.body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.who {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-dense);
}

.checks {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-chip);
}

.checks legend {
  padding: 0 4px;
  font-size: var(--t-dense);
  font-weight: 600;
}

.check {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: var(--t-dense);
  font-weight: 400;
}

.check input {
  margin-top: 3px;
}

.summary {
  margin: 0;
  padding: 10px 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-chip);
  background: var(--panel);
  font-size: var(--t-dense);
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.small {
  min-height: var(--h-ctl);
  padding: 0 10px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--accent);
  font: inherit;
  font-size: var(--t-min);
  font-weight: 600;
  cursor: pointer;
}

.small:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: not-allowed;
}
